const playerData = require('playerData');
const constants = require('constants');
const resourceUtil = require('resourceUtil');
const HttpUtil = require("HttpUtil");

cc.Class({
    extends: cc.Component,

    properties: {
        lbPrice: cc.Label,
        lbGold: cc.Label,
    },

    start() {

    },

    refresh() {
        this.show(this.shopData, this._parent);
    },

    show(shopData, parent) {
        this._parent = parent;
        this.shopData = shopData;
        this.lbPrice.string = "$" + this.shopData.price;
        this.lbGold.string = this.shopData.name;
    },

    onBtnItemClick() {
        cc.gameSpace.audioManager.playSound(constants.AUDIO_SOUND.CHANGE_WEAPON);

        if (cc.gameSpace.userId) {
            var url = "user_id=" + cc.gameSpace.userId + "&price=" + this.shopData.price + "&goodsName=" + this.shopData.appPurchaseName;
            HttpUtil.openPay(url);
        }
    },

});